const Config = {
  SWIFTYPE_ENGINE_KEY: process.env.SWIFTYPE_ENGINE_KEY || '',
  SWIFTYPE_API_ENDPOINT: process.env.SWIFTYPE_API_ENDPOINT || '',
  RECAPTCHA_KEY: process.env.RECAPTCHA_KEY || '',
  NETLIFY_CONTACT_FORM_NAME: process.env.NETLIFY_CONTACT_FORM_NAME,
};

export default Config;
